<div class="session-top">
  <div class="side-content" [@handleSideMenuOpened]="!!sideMenuOpened">
    <div class="side-menu-container">
      <app-list class="side-menu-list" [items]="sideMenuItems">
        <ng-template listItem let-item="item">
          <div
            class="menu-item"
            (click)="item.onClick?.()"
            [appBlockModalDrag]="!isMobileMode"
          >
            {{ item.text }}
          </div>
        </ng-template>
      </app-list>

      <div
        *ngIf="isMobileMode"
        class="handle"
        (click)="sideMenuOpened = !sideMenuOpened"
      >
        <app-iconic
          childItemsToAnim
          [@handleIndicatorOpened]="!!sideMenuOpened"
          class="icon"
          icon="assets/icons/caret-left.svg"
        ></app-iconic>
      </div>
    </div>
  </div>

  <div class="main-content" [ngClass]="{ 'mobile-mode': isMobileMode }">
    <app-scroll-view class="scroll-view">
      <div #resultsViewContainerEl class="results-container">
        <ng-container [ngSwitch]="resultsViewTypeSelected">
          <app-results-table-view
            *ngSwitchCase="resultsViewTypes.Table"
            class="view"
            [(pageIndex)]="tableViewPageIndex"
            (onGraphicZoomed)="onGraphicZoomedInternal($event)"
          ></app-results-table-view>

          <app-results-chart-view
            *ngSwitchCase="resultsViewTypes.Chart"
            class="view"
            [(fieldSelected)]="chartViewFieldSelected"
          ></app-results-chart-view>

          <app-results-statistics-view
            *ngSwitchCase="resultsViewTypes.Statistics"
            class="view"
            [(fieldSelected)]="statisticsViewFieldSelected"
            [(pageIndex)]="statisticsViewPageIndex"
          ></app-results-statistics-view>
        </ng-container>

        <app-loading-panel
          [visible]="loadingController.changes | async"
          [container]="resultsViewContainerEl"
        ></app-loading-panel>
      </div>

      <div class="filter-list-container">
        <app-list
          class="filter-list"
          [items]="filterItemList"
          keyExpr="id"
          [scrollable]="!isMobileMode"
          emptyMessage="Não há filtros"
        >
          <ng-template listContainer let-itemListTemplate="itemListTemplate">
            <div class="content">
              <ng-template [ngTemplateOutlet]="itemListTemplate"></ng-template>
            </div>
          </ng-template>

          <ng-template listItem let-item="item">
            <div
              class="filter-item"
              (click)="onFilterItemRemoveClick(item)"
              [appBlockModalDrag]="!isMobileMode"
            >
              <span class="text">
                <app-filter-text
                  [item]="item"
                  [fields]="fieldsObservable | async"
                ></app-filter-text>
              </span>

              <span class="remove-text">Remover</span>
            </div>
          </ng-template>
        </app-list>
      </div>
    </app-scroll-view>
  </div>
</div>

<div class="actions-bottom">
  <app-scroll-view class="scroll-view" [horizontal]="true" [vertical]="false">
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Tabela"
        (click)="resultsViewTypeSelected = resultsViewTypes.Table"
      ></app-button>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Gráfico"
        (click)="resultsViewTypeSelected = resultsViewTypes.Chart"
      ></app-button>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Estatísticas"
        (click)="resultsViewTypeSelected = resultsViewTypes.Statistics"
      ></app-button>
    </div>

    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text=".XLSX"
        [disabled]="!(canExportObservable | async)"
        (click)="onBtnExportXlsxClick()"
      ></app-button>
    </div>
    <div
      class="btn-item"
      [ngClass]="{
        'not-allowed': !(canExportShpObservable | async)
      }"
      [appBlockModalDrag]="!isMobileMode"
      #btnItemShpEl
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text=".SHP"
        [disabled]="!(canExportShpObservable | async)"
        (click)="onBtnExportShpClick()"
      ></app-button>

      <app-tooltip
        *ngIf="!(canExportShpObservable | async)"
        [target]="btnItemShpEl"
        verticalAlignment="top"
        horizontalAlignment="center"
      >
        Não é possível exportar neste formato
      </app-tooltip>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Histórico"
        (click)="onBtnFilterHistoryClick()"
      ></app-button>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Gravar"
        (click)="onBtnOpenSaveFilterModalClick()"
      ></app-button>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Limpar"
        (click)="onBtnClearClick()"
      ></app-button>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Filtrar"
        (click)="onBtnFilterOnMapClick()"
        [disabled]="isFilterDisabled"
      ></app-button>
    </div>
    <div class="btn-item" [appBlockModalDrag]="!isMobileMode">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="Aplicar"
        (click)="onBtnFilterClick()"
        [disabled]="isFilterDisabled"
      ></app-button>
    </div>
  </app-scroll-view>
</div>

<app-localization-filter-form
  *appDeferRendering="localizationFilterModalVisible"
  [(visible)]="localizationFilterModalVisible"
  [fields]="fieldsObservable | async"
></app-localization-filter-form>

<app-entity-type-filter-form
  *appDeferRendering="entityTypeFilterModalVisible"
  [(visible)]="entityTypeFilterModalVisible"
></app-entity-type-filter-form>

<app-object-type-filter-form
  *appDeferRendering="objectTypeFilterModalVisible"
  [(visible)]="objectTypeFilterModalVisible"
  [mainMapImageLayer]="mainMapImageLayer"
></app-object-type-filter-form>

<app-entity-filter-form
  *appDeferRendering="entityFilterModalVisible"
  [(visible)]="entityFilterModalVisible"
></app-entity-filter-form>

<app-attributes-filter-form
  *appDeferRendering="attributesFilterModalVisible"
  [(visible)]="attributesFilterModalVisible"
  [fields]="fieldsObservable | async"
></app-attributes-filter-form>

<app-object-id-filter-form
  *appDeferRendering="objectIdFilterModalVisible"
  [(visible)]="objectIdFilterModalVisible"
></app-object-id-filter-form>

<app-filter-history
  *appDeferRendering="filterHistoryModalVisible"
  [(visible)]="filterHistoryModalVisible"
></app-filter-history>

<app-save-filter-form
  *appDeferRendering="saveFilterModalVisible"
  [(visible)]="saveFilterModalVisible"
></app-save-filter-form>

<ng-container *ngIf="!!(floatingFilterVisible && floatingFilterContainer)">
  <div
    class="floating-filter-wrapper"
    [appPortalRender]="floatingFilterContainer"
  >
    <app-floating-filter
      [fields]="fieldsObservable | async"
    ></app-floating-filter>
  </div>
</ng-container>

<app-confirm-modal
  [(visible)]="exportConfirmModalVisible"
  modalTitle="Exportação"
  modalMessage="Não é possível exportar toda a informação. Para mais informações, aceder o manual de integração."
  (onPositiveClick)="exportShp()"
></app-confirm-modal>
